'use strict';

/**
 * 一键快签 - 定时快签 弹窗
 * 2019-05-06
 * fanglijuan
 */
angular.module('appQuickSignTimingSignModule', [])
    . controller('appQuickSignTimingSignCtrl', ['$scope', '$q', '$state', '$modalInstance', '$filter', 'obj', function($scope, $q, $state, $modalInstance, $filter, obj) {
        initStatus();

        /**
     * [initStatus description] 初始化状态
     * @return {[type]} [description]
     */
        function initStatus() {
            $scope.status = {
                sharedDate: new Date(),
                modalTitle: '选中稿件' + obj.length + '项',
            };
            // 多个稿件修改定时签发,取当前时间加1分钟
            if (obj.length > 1) {
                $scope.status.sharedDate = $scope.status.sharedDate.setMinutes($scope.status.sharedDate.getMinutes() + 1);
            }
        }

        // 确定
        $scope.confirm = function() {
            var timeSigned = $filter('date')($scope.status.sharedDate, 'yyyy-MM-dd HH:mm').toString();
            $modalInstance.close(timeSigned);
        };

        /**
     * [cancel description] 取消
     * @return {[type]} [description]
     */
        $scope.cancel = function() {
            $modalInstance.dismiss();
        };
    }]);
